// ScreenSavvy Theme Configuration
export const theme = {
  colors: {
    primary: {
      50: '#eef2ff',
      100: '#e0e7ff',
      200: '#c7d2fe',
      300: '#a5b4fc',
      400: '#818cf8',
      500: '#6366f1',
      600: '#4f46e5',
      700: '#4338ca',
      800: '#3730a3',
      900: '#312e81',
    },
    accent: {
      violet: '#8b5cf6',
      fuchsia: '#d946ef',
      pink: '#ec4899',
      rose: '#f43f5e',
      orange: '#f97316',
      amber: '#f59e0b',
      emerald: '#10b981',
      teal: '#14b8a6',
      cyan: '#06b6d4',
      sky: '#0ea5e9',
    },
    gradient: {
      primary: 'from-indigo-600 via-purple-600 to-pink-500',
      secondary: 'from-cyan-500 via-blue-500 to-indigo-500',
      accent: 'from-amber-400 via-orange-500 to-rose-500',
      success: 'from-emerald-400 via-teal-500 to-cyan-500',
      dark: 'from-slate-800 via-slate-900 to-slate-950',
    },
  },
  shadows: {
    glow: {
      primary: '0 0 40px -10px rgba(99, 102, 241, 0.5)',
      accent: '0 0 40px -10px rgba(236, 72, 153, 0.5)',
      success: '0 0 40px -10px rgba(16, 185, 129, 0.5)',
    },
  },
};

// Stat card color configurations
export const statCardColors = [
  { gradient: 'from-blue-500 to-indigo-600', shadow: 'shadow-blue-200', icon: 'text-blue-100' },
  { gradient: 'from-emerald-500 to-teal-600', shadow: 'shadow-emerald-200', icon: 'text-emerald-100' },
  { gradient: 'from-amber-500 to-orange-600', shadow: 'shadow-amber-200', icon: 'text-amber-100' },
  { gradient: 'from-purple-500 to-fuchsia-600', shadow: 'shadow-purple-200', icon: 'text-purple-100' },
  { gradient: 'from-pink-500 to-rose-600', shadow: 'shadow-pink-200', icon: 'text-pink-100' },
  { gradient: 'from-cyan-500 to-sky-600', shadow: 'shadow-cyan-200', icon: 'text-cyan-100' },
];

// Badge color variants
export const badgeColors = {
  success: 'bg-gradient-to-r from-emerald-50 to-teal-50 text-emerald-700 ring-emerald-500/20',
  warning: 'bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700 ring-amber-500/20',
  danger: 'bg-gradient-to-r from-red-50 to-rose-50 text-red-700 ring-red-500/20',
  info: 'bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 ring-blue-500/20',
  purple: 'bg-gradient-to-r from-purple-50 to-fuchsia-50 text-purple-700 ring-purple-500/20',
  default: 'bg-gradient-to-r from-gray-50 to-slate-50 text-gray-700 ring-gray-500/20',
};

